import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'js/withRouter';

import { updateActiveCms } from 'actions/LayoutActions';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';

class Home extends React.Component {
  componentDidMount = () => {
    this.props.updateActiveCms('cmsSystemPageHome');
    this.checkAndRedirect();
  };

  componentDidUpdate = () => {
    this.checkAndRedirect();
  };

  checkAndRedirect = () => {
    const { user, history, appIntl } = this.props;

    // If user is logged in, redirect to account dashboard
    // This avoids the CMS page loading issue and provides a better UX
    if (user.logged) {
      history.replace(appIntl.urlPrefix + 'account');
    }
  };

  componentWillUnmount = () => {
    this.props.updateActiveCms(null);
  };

  render() {
    const { cmsPage, height, user } = this.props;

    // Don't render anything if user is logged in (they'll be redirected)
    if (user.logged) {
      return null;
    }

    return (
      <>

        {!cmsPage.data.id && <Data dataName="cmsSystemPageHome" url="/api/pages/home.json" data={cmsPage} />}

        {cmsPage.pending ? (
          <div className="content relative" style={{ height: `${height}px` }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}>
              <Loader />
            </div>
          </div>
        ) : (
          <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />
        )}

      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    height: state.layout.height,
    cmsPage: state.data.cmsSystemPageHome,
    user: state.login.user,
    appIntl: state.intl,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateActiveCms: activeCms => {
      dispatch(updateActiveCms(activeCms));
    },
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Home));
